import { encodeOpts as paramsSerializer } from '@/utils/encode-opts';

const quickbooksApiFactory = (axios) => ({
  getBankAccounts: async (customerQBId, distributorId) =>
    (await axios.get(`qb/customers/${customerQBId}/bankaccounts`, { params: { distributorId }, paramsSerializer }))
      .data,
});

export { quickbooksApiFactory };
